var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Provides the reusable card container for sections of break-in damage descriptions.
 * touches: break-in damage description layout, UiCard, optional section title/subtitle content.
 * invariants: title/subtitle are optional; the subtitle gets error styling only when hasError is true; section content comes through the default slot.
 * inputs: optional title, subtitle, hasError state, plus slotted section content.
 * outputs: renders a styled UiCard containing the optional sanitized title/subtitle and section content.
 */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UiCard } from '@claims-ia/design-system';
let BreakInDamageDescriptionSectionCard = class BreakInDamageDescriptionSectionCard extends Vue {
};
__decorate([
    Prop({ type: String, default: null })
], BreakInDamageDescriptionSectionCard.prototype, "title", void 0);
__decorate([
    Prop({ type: String, default: null })
], BreakInDamageDescriptionSectionCard.prototype, "subtitle", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BreakInDamageDescriptionSectionCard.prototype, "hasError", void 0);
BreakInDamageDescriptionSectionCard = __decorate([
    Component({
        components: { UiCard },
    })
], BreakInDamageDescriptionSectionCard);
export default BreakInDamageDescriptionSectionCard;
